<mat-card class="box" [style.background-color]="cardBackgroundColor" (click)="onClickPressed()">
  <img alt="" [src]="cardIcon" />
  <p class="title" [style.color]="cardTitleColor">{{ cardTitle | translate }}</p>
</mat-card>
